export const UI_UPDATE_ALERT = 'ui_update_alert';
